module.exports = __webpack_public_path__ + "static/img/handsize.636f9903.png";